import { ListFinalCalculation } from './ListFinalCalculation';
import Product from './Product';
import { Reference } from './Reference';

export default class List {
	products: Product[];

	finalCalculation: ListFinalCalculation;

	reference: Reference;

	links: { [key: string]: string };

	constructor(
		products: Product[],
		finalCalculation: ListFinalCalculation,
		reference: Reference,
		links: { [key: string]: string }
	) {
		this.products = products;
		this.finalCalculation = finalCalculation;
		this.reference = reference;
		this.links = links;
	}

	getExportXlsLink(): string {
		return this.links['export-xls'];
	}
}
